import { render, staticRenderFns } from "./PurchaseSettlement2.vue?vue&type=template&id=5f7fc860&"
import script from "./PurchaseSettlement2.vue?vue&type=script&lang=js&"
export * from "./PurchaseSettlement2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports